import React, {useEffect, useState} from 'react';
import Layout from './Layout';
import {PageRoute} from "../models/PageRoute";
import AppContext from '../context/AppContext';
import {ReCaptcha} from "./Recaptcha";
import {IAppContext} from "../context/AppContext";
import {useParams} from "react-router-dom";

const VerifyCaptchaForDownloadPage: React.FC<PageRoute> = (route: PageRoute) => {
  const params = useParams();
  const qsaId: string | undefined = params.qsaId;

  const downloadUrl = qsaId ? `/api/download_file/${qsaId}` : "/";

  const [recaptchaRequired, setRecaptchaRequired] = useState<boolean>(true);

  useEffect(() => {
    // re-render please.
  }, [recaptchaRequired]);

  const redirectToDownload = () => {
    window.location.assign(downloadUrl);
  };

  if (!qsaId) {
    return <Layout><h1>Invalid download request</h1></Layout>;
  }

  if (recaptchaRequired) {
    return (
        <Layout>
          <h1>Digital Copy</h1>

          <p>Please verify you are a human to continue to your download.</p>

          <AppContext.Consumer>
            {(context: IAppContext): React.ReactElement => {
              if (!context.user && !context.captchaVerified) {
                return <ReCaptcha context={context} onSuccess={() => {
                  setRecaptchaRequired(false);
                  redirectToDownload();
                }}/>;
              } else {
                setRecaptchaRequired(false);
                redirectToDownload();
                return <></>;
              }
            }}
          </AppContext.Consumer>

        </Layout>
    );
  } else {
    return (
      <Layout>
        <h1>Digital Copy - Download in progress...</h1>
        <p>Your download should start automatically.</p>
        <p>If not, please <a href={downloadUrl}>click here</a> to download manually.</p>
      </Layout>
    );
  }
};

export default VerifyCaptchaForDownloadPage;
